import { InjectionToken } from '@angular/core';
import { DocumentDetailState } from '../types';

export const submittedDetailInitialState: DocumentDetailState = {
  canDialogClose: false,
  data: {
    attribute_type: {
      description: '',
      id: '',
      iris_entity_id: undefined,
      name: '',
    },
    attribute_type_id: '',
    complete_timestamp: null,
    created_by_user: {
      email: '',
      first_name: '',
      id: '',
      is_internal: false,
      last_name: '',
      legacy_id: null,
    },
    created_dt: '',
    data: {
      is_reviewer_document: false,
    },
    document_description: null,
    document_id: '',
    document_status: '',
    document_tasks: [],
    document_type: {
      attribute_type_id: null,
      attribute_type_name: null,
      description: '',
      id: '',
      name: '',
    },
    document_type_id: '',
    entity_id: '',
    entity_type: '',
    id: '',
    int_id: 0,
    is_additional: false,
    is_complete: false,
    is_outcome: false,
    is_resolved: null,
    is_response: false,
    is_reviewer_document: false,
    legacy_id: null,
    location: '',
    messages: null,
    name: '',
    next: null,
    previous: null,
    required: '',
    sites: null,
    title: '',
    transmitted_timestamp: null,
    updated_dt: '',
    wcg_name: '',
    workspace_id: null,
  },
  documentError: null,
  documentLoading: false,
  documentSrc: null,
  error: null,
  loading: true,
};

export const SUBMITTED_DOCUMENT_DETAIL_STATE =
  new InjectionToken<DocumentDetailState>('Submitted Documents Detail state', {
    factory: () => ({ ...submittedDetailInitialState }),
  });
